export const NotSpaceCharOnlyString = /.*\S+.*/;
export const UuidString = /^[a-zA-Z0-9+-]*$/;
export const UuidValidLengthString = /^\S(?=(?:.{18}|.{19}|.{35}|.{36})$)/;
export const NhsString = /^\s*(?:[\d]\s*){10}$/;
export const AlphanumericAndCommonSymbols = /^[A-z0-9 /+&*^?!.,'()@\n\t]*$/;
